// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"5173f9d0","208":"5a0e776d"}[chunkId] + ".chunk.js";
};